<template>
  <div class="bg-white dark:bg-bs-dark-bg-over rounded-3xl tip-item p-3 flex-1 mt-8">
    <h1
      horizontalAlignment="left"
      class="font-bold text-2xl text-bs-dark-bg dark:text-white text-left pt-0 mb-4 w-full d-block"
    >
      Game Stats <span class="text-sm font-normal">({{ minute }}")</span>
    </h1>

    <div v-for="pair in pairs" :key="pair.title" class="w-full flex justify-between mt-4">
      <div class="flex justify-end w-4/12">
        <div
          class="bg-bs-gray-dark rounded-full w-full h-6 flex justify-end overflow-hidden relative"
        >
          <span class="font-bold text-xs mb-1 text-white absolute right-0 mr-4 mt-1">{{
            pair.home
          }}</span>
          <div
            class="h-6 bg-bs-blue-dark rounded-full"
            :style="{ width: `${pair.percentHome}%` }"
          />
        </div>
      </div>
      <span class="text-xs dark:text-white text-center">{{ pair.title }}</span>
      <div class="flex justify-end w-4/12">
        <div
          class="bg-bs-gray-dark rounded-full w-full h-6 flex justify-start overflow-hidden relative"
        >
          <span class="font-bold text-xs mb-1 text-white absolute left-0 ml-4 mt-1">{{
            pair.away
          }}</span>
          <div
            class="h-6 bg-bs-green rounded-full"
            :style="{ width: `${pair.percentAway}%` }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "homeOnTarget",
    "homeOffTarget",
    "homeAttacks",
    "homePossession",
    "homeDangerousAttacks",
    "homeCorners",
    "awayOnTarget",
    "awayOffTarget",
    "awayAttacks",
    "awayPossession",
    "awayDangerousAttacks",
    "awayCorners",
    "minute",
  ],
  data: function () {},
  computed: {
    totalOnTarget() {
      return this.homeOnTarget + this.awayOnTarget;
    },
    totalOffTarget() {
      return this.homeOffTarget + this.awayOffTarget;
    },
    totalAttacks() {
      return this.homeAttacks + this.awayAttacks;
    },
    totalDangerousAttacks() {
      return this.homeDangerousAttacks + this.awayDangerousAttacks;
    },
    totalCorners() {
      return this.homeCorners + this.awayCorners;
    },
    pairs: function () {
      return [
        {
          title: "Shots On Target",
          home: this.homeOnTarget,
          percentHome: (this.homeOnTarget / this.totalOnTarget) * 100,
          away: this.awayOnTarget,
          percentAway: (this.awayOnTarget / this.totalOnTarget) * 100,
          total: this.totalOnTarget,
        },
        {
          title: "Shots Off Target",
          home: this.homeOffTarget,
          percentHome: (this.homeOffTarget / this.totalOffTarget) * 100,
          away: this.awayOffTarget,
          percentAway: (this.awayOffTarget / this.totalOffTarget) * 100,
          total: this.totalOffTarget,
        },
        {
          title: "Attacks",
          home: this.homeAttacks,
          percentHome: (this.homeAttacks / this.totalAttacks) * 100,
          away: this.awayAttacks,
          percentAway: (this.awayAttacks / this.totalAttacks) * 100,
          total: this.totalAttacks,
        },
        {
          title: "Dangerous Attacks",
          home: this.homeDangerousAttacks,
          percentHome: (this.homeDangerousAttacks / this.totalDangerousAttacks) * 100,
          away: this.awayDangerousAttacks,
          percentAway: (this.awayDangerousAttacks / this.totalDangerousAttacks) * 100,
          total: this.totalDangerousAttacks,
        },
        {
          title: "Corners",
          home: this.homeCorners,
          percentHome: (this.homeCorners / this.totalCorners) * 100,
          away: this.awayCorners,
          percentAway: (this.awayCorners / this.totalCorners) * 100,
          total: this.totalCorners,
        },
        {
          title: "Ball Posession",
          home: `${this.homePossession}%`,
          percentHome: this.homePossession,
          away: `${this.awayPossession}%`,
          percentAway: this.awayPossession,
        },
      ];
    },
  },
  methods: {
    formatNumber: function (n) {
      return n?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style></style>
